import React, { useContext } from "react";
import { AppContext } from "./../AppContext";
import { formatNumer } from "../Web3/Function";

function Redeem({ selectedToken = "ICUSD" }) {
  const { tatalSBsc } = useContext(AppContext);

  return (
    <div className="m-t-2">
      <div className="row">
        <div className="col-12 b-r_1">
          <div className="d-f a-i-c j-c-s-b m-q-m-b-2">
            <div className="f-w-600 t-a-l">Total {selectedToken} Minted (BSC)</div>
            <div>{formatNumer(tatalSBsc)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Redeem;
